module.exports = __webpack_public_path__ + "img/bell-regular.92ebc57d.svg";